var $ = require('../internals/export');
var global = require('../internals/global');
var setImmediate = require('../internals/task').set;

// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({ global: true, bind: true, enumerable: true, forced: global.setImmediate !== setImmediate }, {
  setImmediate: setImmediate
});



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/web.set-immediate.js
// module id = 1s8w
// module chunks = 04af